import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import { IdoSdkState } from '../models';

@Injectable({
  providedIn: 'root'
})
export class SdkStateService {
  private readonly STORAGE_KEY = 'idoSdkState';
  constructor() { }

  public getState(): IdoSdkState | null {
    const state = sessionStorage.getItem(this.STORAGE_KEY);
    if (!state) return null;
    try {
      const parsedState: IdoSdkState = JSON.parse(state);
      if (parsedState && typeof parsedState.expiresAt === 'number' && parsedState.expiresAt > Date.now()) {
        return parsedState;
      }
      // Si el estado ha expirado, limpiarlo y retornar null
      this.clearState();
      return null;
    } catch (err) {
      // console.log('[SdkStateService] Invalid serialized state, clearing it', err);
      this.clearState();
      return null;
    }
  }

  public async setState(journeyName: string, debugPin?: string) {
    try {
      const serialized = window?.tsPlatform?.ido?.serializeState();
      if (!serialized) {
        console.warn('[SdkStateService] serializeState returned empty, skipping persist');
        return;
      }
      const newState: IdoSdkState = {
        state: serialized,
        expiresAt: Date.now() + environment.mosaic.stateExpirationTimeInMilliseconds,
        journeyName,
        debugPin,
      };
      sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(newState));
    } catch (err) {
      console.error('[SdkStateService] Failed to serialize or persist state', err);
    }
  }

  public clearState(): void {
    //console.log('[StateService] Removing state');
    sessionStorage.removeItem(this.STORAGE_KEY);
    localStorage.removeItem(this.STORAGE_KEY);
  }
}
